// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styleGeneral:hover {\n  text-decoration: underline;\n  text-decoration-color: #51a45c;\n}", "",{"version":3,"sources":["webpack://./src/components/rights/rightsList.vue"],"names":[],"mappings":"AACA;EACE,0BAAA;EACA,8BAAA;AAAF","sourcesContent":["\n.styleGeneral:hover {\n  text-decoration: underline;\n  text-decoration-color: #51a45c;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
